class DLPageReviewsM extends HTMLElement {
  constructor() {
    super();
    this.glideContainer = this.querySelector('.glide');
    this.dot = this.querySelector('.dl-page-reviews-m-dot');
    this.dotsTrack = this.querySelector('.dl-page-reviews-m-dots');
    this.blockCount = parseInt(this.dotsTrack?.style.getPropertyValue('--block-count') || '1', 10);
    this.initializeGlide();
    this.initDotDrag();
    window.addEventListener('resize', this.onResize.bind(this));
  }

  initializeGlide() {
    this.glide = new Glide(this.glideContainer, {
      type: 'carousel',
      startAt: 0,
      perView: window.innerWidth < 990 ? 1.121 : 3.46,
      gap: 16,
    });
    this.glide.on('run.after', this.updateDot.bind(this));
    this.glide.mount();
  }

  updateDot() {
    if (!this.dot || this._dragActivated) return;
    const index = this.glide.index;
    this.dot.style.transform = `translateX(${index * 100}%)`;
  }

  initDotDrag() {
    if (!this.dotsTrack) return;

    this.dotsTrack.style.cursor = 'grab';

    const getIndexFromEvent = (e) => {
      const rect = this.dotsTrack.getBoundingClientRect();
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      const ratio = Math.max(0, Math.min(1, (clientX - rect.left) / rect.width));
      return Math.min(Math.round(ratio * this.blockCount), this.blockCount - 1);
    };

    const DRAG_THRESHOLD = 4;

    const onDragStart = (e) => {
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      this._dragStartX = clientX;
      this._dragActivated = false;
      this._dragging = true;
    };

    const onDragMove = (e) => {
      if (!this._dragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      if (!this._dragActivated) {
        if (Math.abs(clientX - this._dragStartX) < DRAG_THRESHOLD) return;
        this._dragActivated = true;
        this.dot.style.transition = 'none';
        this.dotsTrack.style.cursor = 'grabbing';
        document.body.style.cursor = 'grabbing';
      }
      e.preventDefault();
      const index = getIndexFromEvent(e);
      this.dot.style.transform = `translateX(${index * 100}%)`;
      if (index !== this._lastDragIndex) {
        this._lastDragIndex = index;
        this.glide.go(`=${index}`);
      }
    };

    const onDragEnd = () => {
      if (!this._dragging) return;
      this._dragging = false;
      this.dot.style.transition = '';
      this.dotsTrack.style.cursor = 'grab';
      document.body.style.cursor = '';
      this._lastDragIndex = undefined;
      this._dragActivated = false;
    };

    this.dotsTrack.addEventListener('mousedown', onDragStart);
    this.dotsTrack.addEventListener('touchstart', onDragStart, { passive: false });
    window.addEventListener('mousemove', onDragMove);
    window.addEventListener('touchmove', onDragMove, { passive: false });
    window.addEventListener('mouseup', onDragEnd);
    window.addEventListener('touchend', onDragEnd);
  }

  onResize() {
    if (!this.glide) return;
    this.glide.update({ perView: window.innerWidth < 990 ? 1.121 : 3.4455 });
  }
}

customElements.define('dl-page-reviews-m', DLPageReviewsM);
